// Module
var code = `<div class="invalid-fields"><p class="title">{{errorMessageKey || 'front_royal_form.invalid_fields_links.please_complete_fields' | translate}}</p><div class="field" ng-repeat="field in invalidFieldsProxy" ng-click="scrollToField(field)"><span><i class="fas fa-caret-up"></i>{{labelText(field)}}</span></div></div>`;
// Exports
export default code;